(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-brevo-newsletter"] && !Shopify.designMode) return;
  try {
    
  (function () {
  document.addEventListener('DOMContentLoaded', () => {
    const form = document.getElementById('sib-form-newsletter');
    if (!form) return;

    const container = form.closest('#sib-form-container');
    const errorEl   = container.querySelector('#error-message');
    const successEl = container.querySelector('#success-message');
    const btn       = form.querySelector('[type="submit"]');

    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      errorEl.style.display   = 'none';
      successEl.style.display = 'none';
      btn.disabled = true;

      try {
        await fetch(form.action, {
          method: 'POST',
          body: new FormData(form),
          mode: 'no-cors',
        });
        successEl.style.display = 'block';
        form.reset();
      } catch {
        errorEl.style.display = 'block';
      } finally {
        btn.disabled = false;
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["single-branch-details"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('branch-map')) {
    class BranchMap extends HTMLElement {
      #mapEl = null;
      #fallback = null;

      connectedCallback() {
        this.#mapEl = this.querySelector('[data-map-el]');
        this.#fallback = this.querySelector('[data-map-fallback]');

        const placeId = this.dataset.placeId;
        if (!placeId || !this.#mapEl) {
          this.#showFallback();
          return;
        }

        this.#loadGoogleMaps()
          .then(() => this.#fetchPlace(placeId))
          .catch(() => this.#showFallback());
      }

      #loadGoogleMaps() {
        if (window.google?.maps?.places) return Promise.resolve();

        return new Promise((resolve, reject) => {
          const existing = document.querySelector('script[data-google-maps]');
          if (existing) {
            existing.addEventListener('load', () => resolve());
            existing.addEventListener('error', reject);
            return;
          }
          const script = document.createElement('script');
          script.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyBCHOFkexiv1FAxJM0RalJEiqTXp-wqHuM&libraries=places&v=weekly&callback';
          script.async = true;
          script.dataset.googleMaps = 'true';
          script.addEventListener('load', () => resolve());
          script.addEventListener('error', reject);
          document.head.append(script);
        });
      }

      #fetchPlace(placeId) {
        return new Promise((resolve, reject) => {
          const helper = document.createElement('div');
          const service = new window.google.maps.places.PlacesService(helper);
          service.getDetails(
            { placeId, fields: ['geometry', 'rating', 'user_ratings_total'] },
            (place, status) => {
              if (status !== window.google.maps.places.PlacesServiceStatus.OK || !place?.geometry) {
                reject(new Error('place lookup failed'));
                return;
              }
              this.#renderMap(place.geometry.location.lat(), place.geometry.location.lng());
              this.#renderRating(place.rating, place.user_ratings_total);
              resolve();
            }
          );
        });
      }

      #renderRating(rating, total) {
        if (!rating) return;
        const wrap = this.closest('[data-section]')?.querySelector('[data-branch-rating]');
        const starsEl = wrap?.querySelector('[data-branch-rating-stars]');
        const countEl = wrap?.querySelector('[data-branch-rating-count]');
        if (!wrap || !starsEl || !countEl) return;

        starsEl.textContent = '★'.repeat(Math.round(rating));
        countEl.textContent = total ? `${rating} (${total})` : `${rating}`;
        wrap.hidden = false;
      }

      #renderMap(lat, lng) {
        this.#loadLeaflet()
          .then(() => {
            const map = window.L.map(this.#mapEl).setView([lat, lng], 16);
            window.L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
              attribution: '&copy; OpenStreetMap contributors',
            }).addTo(map);
            window.L.marker([lat, lng])
              .addTo(map)
              .bindPopup(`<strong>${this.dataset.title || ''}</strong>`)
              .openPopup();
          })
          .catch(() => this.#showFallback());
      }

      #loadLeaflet() {
        if (window.L) return Promise.resolve();

        const css = document.createElement('link');
        css.rel = 'stylesheet';
        css.href = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.css';
        document.head.append(css);

        return new Promise((resolve, reject) => {
          const script = document.createElement('script');
          script.src = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.js';
          script.addEventListener('load', () => resolve());
          script.addEventListener('error', reject);
          document.head.append(script);
        });
      }

      #showFallback() {
        if (this.#mapEl) this.#mapEl.hidden = true;
        if (this.#fallback) this.#fallback.hidden = false;
      }
    }

    customElements.define('branch-map', BranchMap);
  }

  } catch(e) { console.error(e); }
})();
})();
